// Database API Service - Handles all database operations
import { resolveApiBaseUrl } from './auth';
import { authFetch, authHeaders } from './auth';
import { reportsMethods } from './database/reportsMethods';
import { inventoryMethods } from './database/inventoryMethods';
import { ordersMethods } from './database/ordersMethods';
import { disputesMethods } from './database/disputesMethods';
import { emailMethods } from './database/emailMethods';
import { utilityMethods } from './database/utilityMethods';
import { migrationMethods } from './database/migrationMethods';

class DatabaseAPI {
  constructor() {
    this.baseURL = resolveApiBaseUrl();
  }

  async makeAPICall(endpoint, method = 'GET', data = null) {
    try {
      if (!endpoint.endsWith('/')) {
        endpoint += '/';
      }
      const config = {
        method,
        headers: authHeaders({ 'Content-Type': 'application/json' }),
      };

      if (data && method !== 'GET') {
        config.body = JSON.stringify(data);
      }

      const response = await authFetch(`${this.baseURL}${endpoint}`, config);

      if (!response.ok) {
        let detail = `HTTP error! status: ${response.status}`;
        try {
          const errBody = await response.json();
          if (errBody?.error) detail = errBody.error;
        } catch (_) {
          // ignore
        }
        throw new Error(detail);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error(`API call failed for ${endpoint}:`, error);
      throw error;
    }
  }
}

Object.assign(
  DatabaseAPI.prototype,
  reportsMethods,
  inventoryMethods,
  ordersMethods,
  disputesMethods,
  emailMethods,
  utilityMethods,
  migrationMethods,
);

const databaseAPI = new DatabaseAPI();

export default databaseAPI;
export { apiUrl } from './database/http';
